
































































































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
    name: 'CreatePDF',
    props: [ 'submission', 'formId' ],
    data() {
        return {
            disableButton: false,
            formData: {
                submission: this.$props.submission,
                formId: this.$props.formId,
                formName: '',
                includeHeader: false,
                includeDate: false,
                headerImage: localStorage.getItem('headerImage'),
                headerText: '',
                headerStyle: 'corners',
                includeContactInfo: false,
                contactPosition: 'top',
                contactStyle: 'underline',
                contactEmail: '',
                customTemplate: '',
                display: 'oneCol'
            },
            headerText: '',
            showPDFLink: false,
            PDFLink: '',
            previewHtml: '',
            previewLoading: false,
            previewError: false,
            previewDebounceTimer: null as any
        }
    },
    computed: {
        isFillerTemplate(): boolean {
            return this.formData.customTemplate.includes('FILLER~');
        },
        fillerPreviewUrl(): string {
            const name = this.formData.customTemplate.replace('FILLER~', '');
            return `${this.$store.state.apiUrl}/filler/template/${encodeURIComponent(name)}/file#navpanes=0&toolbar=1`;
        },
        previewUnavailable(): boolean {
            return !!this.formData.customTemplate;
        },
        // Only the fields that actually affect the rendered doc - stringified
        // so the watcher below doesn't need a deep watch on all of formData.
        previewSnapshot(): string {
            const { display, formName, includeDate, includeHeader, headerImage, headerStyle,
                includeContactInfo, contactPosition, contactStyle, contactEmail, customTemplate } = this.formData;
            return JSON.stringify({ display, formName, includeDate, includeHeader, headerImage, headerStyle,
                includeContactInfo, contactPosition, contactStyle, contactEmail, customTemplate,
                headerText: this.headerText });
        }
    },
    watch: {
        previewSnapshot() {
            this.queuePreview();
        }
    },
    created() {
        if(localStorage.getItem('headerText')) {
            this.headerText = ('' + localStorage.getItem('headerText')).replace(/<br \/>/g,"\n");
        }
    },
    mounted() {
        this.fetchPreview();
    },
    methods: {
        queuePreview() {
            clearTimeout(this.previewDebounceTimer);
            if(this.previewUnavailable) { return; }
            this.previewDebounceTimer = setTimeout(this.fetchPreview, 600);
        },
        fetchPreview() {
            if(this.previewUnavailable) { return; }
            this.previewLoading = true;
            this.previewError = false;
            const payload = {
                ...this.formData,
                headerText: this.headerText.replace(/\r\n|\r|\n/g, "<br />")
            };
            axios.post(`${this.$store.state.apiUrl}/pdf/preview`, payload)
                .then(resp => {
                    this.previewHtml = resp.data;
                })
                .catch(e => {
                    console.log(e.response?.data ? e.response.data : e);
                    this.previewError = true;
                })
                .finally(() => {
                    this.previewLoading = false;
                });
        },
        submit() {
            this.formData.headerText = this.headerText.replace(/\r\n|\r|\n/g,"<br />");
            this.disableButton = true;
            this.showPDFLink = false;
            
            let url = `${this.$store.state.apiUrl}/pdf`;
            if(this.formData.customTemplate.includes('FILLER~')) {
                url = `${this.$store.state.apiUrl}/filler/submission`;
            } 
            axios.post(url, this.formData)
                .then(resp => {
                    this.showPDFLink = true;
                    this.PDFLink = `${this.$store.state.apiUrl}/pdf/${resp.data}`;

                    if(this.formData.headerImage) {
                        localStorage.setItem('headerImage', this.formData.headerImage);
                    }
                    if(this.formData.headerText) {
                        localStorage.setItem('headerText', this.formData.headerText);
                    }

                    // window.open(`${this.$store.state.apiUrl}/pdf/${resp.data}`, "_blank");

                    /*if(this.formData.headerImage) {
                        localStorage.setItem('headerImage', this.formData.headerImage);
                    }
                    if(this.formData.headerText) {
                        localStorage.setItem('headerText', this.formData.headerText);
                    }
                    const byteCharacters = atob(resp.data);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const file = new Blob([byteArray], { type: 'application/pdf' });

                    if(this.isIOS()) {
                        const reader = new FileReader();
                        reader.onload = e => {
                            // this.iOSData = (reader as any).result;
                            // this.showPDFLink = true;
                            window.open((reader as any).result, "_blank");
                            window.location.href = (reader as any).result;
                        }
                        reader.readAsDataURL(file);
                    } else {
                        const fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    }*/

                    this.disableButton = false;
                })
                .catch(e => {
                    console.log(e.response?.data ? e.response.data : e);
                    this.disableButton = false;
                })
        },
        closeEdit() {
            this.$emit('closeEdit');
        }
    }
})
